var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 6.565A43.435 43.435 0 1 0 93.435 50 43.484 43.484 0 0 0 50 6.565ZM69.719 59.7a21.92 21.92 0 0 0 0-19.4l16.556-8.14a40.333 40.333 0 0 1 0 35.68Zm-38.7-9.7A18.981 18.981 0 1 1 50 68.981 19 19 0 0 1 31.019 50ZM69.8 14.763l-9.039 16.081a21.906 21.906 0 0 0-21.523 0L30.2 14.763a40.294 40.294 0 0 1 39.592 0ZM13.725 32.16l16.556 8.14a21.92 21.92 0 0 0 0 19.4l-16.556 8.14a40.333 40.333 0 0 1 0-35.68ZM30.2 85.237l9.035-16.082a21.9 21.9 0 0 0 21.524 0L69.8 85.237a40.3 40.3 0 0 1-39.594 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/care.2ca2dc67010e971d9df81766cded904f.svg";
export { ForwardRef as ReactComponent };